import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import ImpersonationBanner from './ImpersonationBanner';
import DemoAccessBanner from './DemoAccessBanner';
import DemoExpiredScreen from './DemoExpiredScreen';
import useIndividualAccess from '../../hooks/useIndividualAccess';
import { useAuth } from '../../contexts/AuthContext';

const Layout = ({ children, role: roleProp }) => {
  const { user } = useAuth();
  const role = roleProp || user?.role;
  const [mobileOpen, setMobileOpen] = useState(false);
  // Owned here (not inside Sidebar) so the main content's left margin can
  // react to it too — previously the sidebar tracked its own collapsed state
  // internally and the content area's `lg:ml-64` never knew about it, leaving
  // a dead gap the width of the difference whenever it was collapsed.
  const [collapsed, setCollapsed] = useState(false);
  const { access, loading: accessLoading } = useIndividualAccess();

  useEffect(() => {
    document.title = user?.organization_name ? `${user.organization_name} — Maximuz Academy` : 'Maximuz Academy';
  }, [user]);

  // An individual student whose demo or paid validity has run out gets the
  // explanation screen instead of an app full of failing requests. Held back
  // until the check resolves so a paying student never sees it flash.
  if (!accessLoading && access?.is_individual && !access.active) {
    return <DemoExpiredScreen access={access} />;
  }

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <Sidebar
        role={role}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((c) => !c)}
      />

      {/* Main Content */}
      <div className={`flex-1 flex flex-col min-w-0 transition-[margin-left] duration-300 ${collapsed ? 'lg:ml-16' : 'lg:ml-64'}`}>
        <Navbar onMobileMenuToggle={() => setMobileOpen(!mobileOpen)} />
        <ImpersonationBanner />
        <DemoAccessBanner access={access} />
        <main className="flex-1 p-4 md:p-6 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
